// Config-driven, API-first. All environment-specific values come from CRA's
// build-time REACT_APP_* vars (see .env) — never hard-coded — so CCFOS can move
// between local / staging / live (or a standalone domain) with no code change.

export const API_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:5100/api';

// Akountant auth API — CCFOS shares Akountant logins via SSO through this host.
// A token is NEVER read from the URL; CCFOS establishes its own session.
export const AKOUNTANT_AUTH_URL =
  process.env.REACT_APP_AKOUNTANT_AUTH_URL || 'http://localhost:5000/api';

// The six markets CCFOS covers — the "CCFOS" acronym, in order.
export const MARKETS = [
  'Currency',
  'Commodities',
  'Crypto',
  'Futures',
  'Options',
  'Stocks',
] as const;
